import { useKeycloak } from '@react-keycloak/web'
import type { KeycloakTokenParsed } from 'keycloak-js'
import { useSelector } from 'react-redux'

import { accountSelector } from '@/user/selectors'

import type { AuthUser } from '../types'

/**
 * Creates a type-safe version of KeycloakTokenParsed by removing its index signature.
 * Only explicitly defined properties will be allowed in StrictKeycloakTokenParsed.
 */
type RemoveIndexSignature<T> = {
  [K in keyof T as string extends K ? never : K]: T[K]
}
type StrictKeycloakTokenParsed = RemoveIndexSignature<KeycloakTokenParsed>

interface ParsedToken extends StrictKeycloakTokenParsed, AuthUser {}

export function useAuth() {
  const { keycloak } = useKeycloak()
  const user = useSelector(accountSelector) as ParsedToken

  return {
    isAuthenticated: keycloak.authenticated,
    user,
    login: keycloak.login,
  }
}
